import IpubDragArea from './src/main'

/* istanbul ignore next */
IpubDragArea.install = function(Vue) {
  Vue.component(IpubDragArea.name, IpubDragArea)
}

export default IpubDragArea
